import { render, staticRenderFns } from "./ContactRoles.vue?vue&type=template&id=104ca4ea"
import script from "./ContactRoles.vue?vue&type=script&lang=js"
export * from "./ContactRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports